import { HttpStatusCode } from '@angular/common/http';
import { HttpError } from './http-error';

export abstract class HttpErrorHandler {
  abstract handle(error: HttpError): void;
  abstract match(statusCode: HttpStatusCode): boolean;
}
